import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type ArrowButtonVariant = 'dark' | 'light' | 'outline';
type ArrowButtonProps = {
  to: string;
  children: React.ReactNode;
  variant?: ArrowButtonVariant;
  className?: string;
};
const variantClasses: Record<ArrowButtonVariant, {
  base: string;
  icon: string;
}> = {
  dark: {
    base: 'bg-ink text-white hover:bg-ink-700',
    icon: 'bg-white text-ink'
  },
  light: {
    base: 'bg-mist text-ink hover:bg-white',
    icon: 'bg-ink text-white'
  },
  outline: {
    base: 'bg-white/10 text-white ring-1 ring-inset ring-white/20 backdrop-blur-sm hover:bg-white/20',
    icon: 'bg-white text-ink'
  }
};
export function ArrowButton({
  to,
  children,
  variant = 'dark',
  className = ''
}: ArrowButtonProps) {
  const v = variantClasses[variant];
  return <Link to={to} className={`group inline-flex items-center gap-4 whitespace-nowrap rounded-xl py-1.5 pl-5 pr-1.5 text-[15px] font-medium transition-colors duration-200 ease-out-strong focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brass ${v.base} ${className}`} data-id="element-392" data-mp="d0mmmuzr9i7t">
      <span data-id="element-393" data-mp="noiq9enbcgk0">{children}</span>
      <span className={`relative grid h-9 w-9 place-items-center overflow-hidden rounded-lg ${v.icon}`} aria-hidden="true" data-id="element-394" data-mp="nmoh0xlemcvr">
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out-strong group-hover:translate-x-7" data-id="element-395" data-mp="dql4qywu8xv3" />
        <ArrowRightIcon className="absolute h-4 w-4 -translate-x-7 transition-transform duration-200 ease-out-strong group-hover:translate-x-0" data-id="element-396" data-mp="3w3t0xb59qu3e" />
      </span>
    </Link>;
}